export const dragHandleClassName = "drag-handle";
